import { modalViewed } from '@/rudder-typer';

interface ModalViewedPayload {
  modalName: string;
  source?: string;
}

export function sendModalViewed({ modalName, source }: ModalViewedPayload) {
  modalViewed({
    modal_name: modalName,
    source,
  });
}
